<template>
    <div class="container">
        <Loading/>
        <template v-if="show">
            <home-page id="page" @next="next" v-if="l === 0" />
            <leve2 id="page" @next="next" @back="backHomePage" v-else-if="l === 2" />
            <leve4 id="page" @next="next" @back="backHomePage" v-else-if="l === 4"/>
            <leve6 id="page" @next="next" @back="backHomePage" v-else-if="l === 6"/>
            <end id="page" @next="next" @back="backHomePage" v-else-if="l === 7"/>
        </template>
        <div :class="['bg', `l${l}`, {extra}]">
            <Weather v-show="l !== 0"></Weather>
            <People :type="l"/>
            <template v-if="show">
                <leve1 id="page" @next="next" v-if="l === 1"/>
                <leve3 id="page" @next="next" v-else-if="l === 3"/>
                <leve5 id="page" @next="next" @back="backHomePage" v-else-if="l === 5"/>
            </template>
        </div>
        <audio
            src="/media/xj.mp3"
            loop
            preload="auto"
            ref="audioPlayer">
        </audio>
    </div>
</template>

<script>
import '@page/xuejinghanlintu/assets/css/animation.styl';
import Weather from '@page/xuejinghanlintu/components/Weather';
import People from '@page/xuejinghanlintu/components/People';
import Loading from '@page/xuejinghanlintu/components/Loading';
import HomePage from '@page/xuejinghanlintu/HomePage';
import Leve1 from '@page/xuejinghanlintu/Leve1';
import Leve2 from '@page/xuejinghanlintu/Leve2';
import Leve3 from '@page/xuejinghanlintu/Leve3';
import Leve4 from '@page/xuejinghanlintu/Leve4';
import Leve5 from '@page/xuejinghanlintu/Leve5';
import Leve6 from '@page/xuejinghanlintu/Leve6';
import End from '@page/xuejinghanlintu/End';
import wxShare from '@utils/wxShare';

export default {
    components: {
        Loading,
        People,
        Weather,
        HomePage,
        Leve1,
        Leve2,
        Leve3,
        Leve4,
        Leve5,
        Leve6,
        End
    },
    data() {
        return {
            leveName: '',
            l: 0,
            show: true,
            bgAnimationTimer: null,
            extra: false
        };
    },
    methods: {
        // setAudioVolume(flg) {
        //     setTimeout(() => {
        //         const nowVolume = +(this.$refs.audioPlayer.volume.toFixed(1));
        //         if ((flg && nowVolume === 0.2) || (!flg && nowVolume === 1)) {
        //             return;
        //         }
        //         this.$refs.audioPlayer.volume = nowVolume + (flg ? -0.1 : 0.1);
        //         this.setAudioVolume(flg);
        //     }, 200);
        // },
        next(i) {
            this.l = i;
            this.show = false;
            if (this.l === 5) {
                setTimeout(() => {
                    this.extra = true;
                }, 3200);
            }
            else {
                this.extra = false;
            }
            this.runBgAnimation();
            this.$refs.audioPlayer.play();
        },
        backHomePage() {
            clearTimeout(this.bgAnimationTimer);
            this.l = 0;
        },
        setTimer() {
            clearTimeout(this.bgAnimationTimer);
            this.show = true;
        },
        runBgAnimation() {
            let speed;
            switch (this.l) {
                case 1:
                    speed = 10;
                    break;
                case 2:
                    speed = 4;
                    break;
                case 3:
                    speed = 3;
                    break;
                case 4:
                    speed = 7;
                    break;
                case 5:
                    speed = 17;
                    break;
                case 6:
                    speed = 3;
                    break;
                case 7:
                    speed = 2;
                    break;
                default:
                    break;
            }
            this.bgAnimationTimer = setTimeout(() => {
                this.setTimer();
            }, speed * 1000);
        }
    },
    mounted() {
        this.$refs.audioPlayer.play();
        wxShare({
            title: '回到宋朝去赏雪',
            desc: '今年冬天，许你一个不一样的瑞雪兆丰年',
            link: window.location.href,
            imgUrl: `${window.location.origin}/img/xj/share_bg.png`
        }, () => {
            this.$refs.audioPlayer.play();
        });
        document.body.addEventListener('touchmove', e => {
            e.preventDefault();
        }, {
            passive: false
        });
    },
    created() {
        document.body.ontouchstart = e => {
            if (e.touches.length >= 2) {
                e.preventDefault();
            }
        };
        document.body.ontouchmove = e => {
            if (e.touches.length >= 2) {
                e.preventDefault();
            }
        };
        document.body.ontouchend = e => {
            if (e.touches.length >= 2) {
                e.preventDefault();
            }
        };
    }
};
</script>

<style lang="stylus">
.container
    size 100%
    overflow hidden
    position relative
    .bg
        position absolute
        bottom 0
        left 0
        size 75vh 100%
        background url('/img/xj/bgimg.jpg') no-repeat
        background-size 100% 100%
        background-position center center
        transition all 1s cubic-bezier(0.24, 0.08, 1, 1)
        &.l1
            transition-duration 10s
            transform-origin left 85%
            transform scale(1.6)
        &.l2
            transition-duration 4s
            transform-origin 32% 95%
            transform scale(4)
        &.l3
            transform-origin left 95%
            transform scale(1.6)
            transition-duration 3s
            transition-timing-function: linear
        &.l4
            transition-duration 7s
            transform-origin left 80%
            transform scale(3.2)
        &.l5
            transform-origin left 95%
            transform scale(1.6)
            transition-duration 3s
            transition-timing-function: linear
            &.extra
                left calc(100% - 75vh)
                transform-origin right 80%
                transition-duration 5s
                transform scale(2)
        &.l6
            transition-duration 3s
            transform-origin right 80%
            transform scale(3)
            left calc(100% - 75vh)
        &.l7
            transition-duration 2s
            transform-origin right bottom
            transform scale(1.6)
            left calc(100% - 75vh)
    .video
        size 100%
        position absolute
        top 0
        left 0
        object-fit cover
    #page
        size 100%
        position absolute
        top 0
        left 0
        z-index 1
</style>
